import { execSync, spawn } from 'child_process';
import type { ExecSyncOptions } from 'child_process';

export interface RunCommandOptions {
  cwd?: string;
}

// Check if a shell executable is available in the user's system PATH
export function hasCommand(cmd: string): boolean {
  try {
    const checkCmd = process.platform === 'win32' ? `where ${cmd}` : `command -v ${cmd}`;
    execSync(checkCmd, { stdio: 'ignore' });
    return true;
  } catch {
    return false;
  }
}

const inheritShellOptions: ExecSyncOptions = {
  stdio: 'inherit',
  shell: process.platform === 'win32' ? 'cmd.exe' : '/bin/sh',
};

// Execute a command synchronously and capture output/return code
export function runCommandSync(cmd: string, args: string[], options: RunCommandOptions = {}): boolean {
  try {
    const fullCmd = `${cmd} ${args.join(' ')}`;
    execSync(fullCmd, { ...inheritShellOptions, cwd: options.cwd });
    return true;
  } catch {
    return false;
  }
}

// Spawn an interactive command that inherits stdin/stdout/stderr
export function runCommandInteractive(cmd: string, args: string[]): Promise<number | null> {
  return new Promise((resolve) => {
    const child = spawn(cmd, args, {
      stdio: 'inherit',
      shell: true,
    });

    child.on('close', (code) => {
      resolve(code);
    });
  });
}
